export default __webpack_public_path__ + "static/media/item-card-placeholder-0f7c213a.c570ab88.jpg";